import { TableHeadersType } from "./tableHeadersType";

export const E_WAY_BILL_REPOST_HEADERS: TableHeadersType[] = [
  {
    label: "NAME",
    value: "name",
  },
  {
    label: "INVOICE TYPE",
    value: "invoice_type",
  },
  {
    label: "E-WAY BILL NO.",
    value: "e_way_bill_no",
  },
  {
    label: "CANCEL RESON",
    value: "cancel_reson",
  },
  {
    label: "EXTEND RESON",
    value: "extend_reson",
  },
  {
    label: "STATUS",
    value: "status",
  },
  {
    label: "ADDED/MODIFIED BY",
    value: "added_by",
  },
   {
    label: "Action",
    value: "action",
  },
];
export const E_INVOICE_BILL_REPOST_HEADERS: TableHeadersType[] = [
  {
    label: "NAME",
    value: "name",
  },
  {
    label: "IRN",
    value: "irn",
  },

  {
    label: "CANCEL REMARK",
    value: "cancel_remark",
  },
  {
    label: "STATUS",
    value: "status",
  },
  {
    label: "ADDED/MODIFIED BY",
    value: "added_by",
  },
  {
    label: "Action",
    value: "action",
  },
];
